import {connectToParent} from "penpal";

const AUTH_ATTEMPT_KEY = 'wppOpenAuthAttempts';
const AUTH_ATTEMPT_LIMIT = 3;

export default function () {
    return {
        inIframe: false,
        supportsThirdPartyCookies: true,
        init() {
            this.checkIframe();

            if (!this.inIframe || !this.supportsThirdPartyCookies) {
                this.$refs.overlay.style.display = 'none';
                return;
            }

            const attempts = this.getAttempts();

            if (attempts >= AUTH_ATTEMPT_LIMIT) {
                console.warn(`⚠️ WPP Open auto-login attempt limit reached (${attempts}); falling back to manual login.`);
                this.$refs.overlay.style.display = 'none';
                return;
            }

            this.incrementAttempts();
            this.authenticate();
        },
        checkIframe() {
            this.inIframe = window !== window.parent;
        },
        authenticate() {
            connectToParent({
                parentOrigin: '*',
                debug: false,
                methods: {
                    receiveOsContext: (context) => {
                        this.$wire.setOpenContext(context);
                    }
                }
            })
                .promise
                .then(({osApi}) => {
                    osApi.getAccessToken()
                        .then(accessToken => {
                            this.$wire.wppOpenAuthentication(accessToken);
                        })
                        .catch(error => {
                            this.$refs.overlay.style.display = 'none';
                            console.error('Error getting access token', error);
                        });
                })
                .catch(error => {
                    this.$refs.overlay.style.display = 'none';
                    console.info('Not running inside WPP Open.');
                });
        },
        getAttempts() {
            try {
                return parseInt(sessionStorage.getItem(AUTH_ATTEMPT_KEY) || '0', 10) || 0;
            } catch (e) {
                return 0;
            }
        },
        incrementAttempts() {
            try {
                sessionStorage.setItem(AUTH_ATTEMPT_KEY, String(this.getAttempts() + 1));
            } catch (e) {
                // ignore
            }
        },
    };
}
